import {createUseQuery, createUseMutation} from "@irati/utils/services/apollo"
import {
  QueryRecognitionAutomationArgs,
  MutationCreateRecognitionAutomationArgs,
  MutationUpdateRecognitionAutomationArgs,
  RecognitionAutomation,
  QueryRecognitionAutomationsArgs,
  MutationUpdateRecognitionAutomationStatusArgs
} from "@irati/types"
import createAutomationMutation from "../apollo/mutation/CreateRecognitionAutomation"
import updateAutomationMutation from "../apollo/mutation/UpdateRecognitionAutomation"
import updateAutomationStatusMutation from "../apollo/mutation/UpdateRecognitionAutomationStatus"
import getAutomationQuery from "../apollo/query/RecognitionAutomation"
import getAutomationsQuery from "../apollo/query/RecognitionAutomations"
const recognitionAutomationErrorCodeMap: Record<string, string> = {
  PBAutomationCreateAutomationFailed: "errors.PBAutomationCreateAutomationFailed",
  PBAutomationNoActiveUsersInTeam: "errors.PBAutomationNoActiveUsersInTeam"
}

export default function recognitionAutomationErrorHandlers(code: string) {
  return recognitionAutomationErrorCodeMap[code] ?? ""
}
export const useRecognitionAutomationQuery = createUseQuery<RecognitionAutomation, QueryRecognitionAutomationArgs>(getAutomationQuery, {
  key: "recognitionAutomation"
})
export const useRecognitionAutomationsQuery = createUseQuery<RecognitionAutomation[], QueryRecognitionAutomationsArgs>(
  getAutomationsQuery,
  {
    key: "recognitionAutomations"
  }
)
export const useCreateRecognitionAutomationMutation = createUseMutation<RecognitionAutomation, MutationCreateRecognitionAutomationArgs>(
  createAutomationMutation,
  {
    key: "createRecognitionAutomation",
    errorHandlers: [recognitionAutomationErrorHandlers]
  }
)
export const useUpdateRecognitionAutomationMutation = createUseMutation<RecognitionAutomation, MutationUpdateRecognitionAutomationArgs>(
  updateAutomationMutation,
  {
    key: "updateRecognitionAutomation",
    errorHandlers: [recognitionAutomationErrorHandlers]
  }
)
export const useUpdateRecognitionAutomationStatusMutation = createUseMutation<
  RecognitionAutomation,
  MutationUpdateRecognitionAutomationStatusArgs
>(updateAutomationStatusMutation, {
  key: "updateRecognitionAutomationStatus",
  errorHandlers: [recognitionAutomationErrorHandlers]
})
